<template>
    <div class="pb-2">
        <v-card dark width="400">
            <div class="d-flex align-start py-1">
                <div class="px-2 flex-grow-1 body-2">
                    {{device.description}}
                </div>
                <div class="caption px-2" style="white-space: nowrap">
                    {{shortDate}}
                </div>
            </div>


            <div class="d-flex align-center pb-1">
                <div class="flex-grow-1">

                    <div
                            v-if="!stat.bins.total && !stat.clockings.total && !stat.barcodes.total && !stat.pieceWorkValues.total && !stat.rollCallValues.total && !stat.intakeValues.total"
                            class="d-flex align-center px-4 pb-1 overline amber--text"
                            style="line-height: 1"
                    >
                        Empty Sync
                    </div>

                    <div
                            v-if="stat.bins.total"
                            class="d-flex align-center px-4 pb-1 overline"
                            style="line-height: 1"
                            :class="!stat.bins.fail ? 'success--text' : 'error--text'"
                    >
                        <div style="white-space: nowrap; width: 120px">Bins</div>
                        <div class="flex-grow-1">{{ stat.bins.total - stat.bins.fail }} of {{ stat.bins.total }} Successfull</div>
                    </div>

                    <div
                            v-if="stat.clockings.total"
                            class="d-flex align-center px-4 pb-1 overline"
                            style="line-height: 1"
                            :class="!stat.clockings.fail ? 'success--text' : 'error--text'"
                    >
                        <div style="white-space: nowrap; width: 120px">Clockings</div>
                        <div class="flex-grow-1">{{ stat.clockings.total - stat.clockings.fail }} of {{ stat.clockings.total }} Successfull</div>
                    </div>

                    <div
                            v-if="stat.barcodes.total"
                            class="d-flex align-center px-4 pb-1 overline"
                            style="line-height: 1"
                            :class="!stat.barcodes.fail ? 'success--text' : 'error--text'"
                    >
                        <div style="white-space: nowrap; width: 120px">Barcodes</div>
                        <div class="flex-grow-1">{{ stat.barcodes.total - stat.barcodes.fail }} of {{ stat.barcodes.total }} Successfull</div>
                    </div>

                    <div
                            v-if="stat.pieceWorkValues.total"
                            class="d-flex align-center px-4 pb-1 overline"
                            style="line-height: 1"
                            :class="!stat.pieceWorkValues.fail ? 'success--text' : 'error--text'"
                    >
                        <div style="white-space: nowrap; width: 120px">Values</div>
                        <div class="flex-grow-1">{{ stat.pieceWorkValues.total - stat.pieceWorkValues.fail }} of {{ stat.pieceWorkValues.total }} Successfull</div>
                    </div>

                    <div
                            v-if="stat.rollCallValues.total"
                            class="d-flex align-center px-4 pb-1 overline"
                            style="line-height: 1"
                            :class="!stat.rollCallValues.fail ? 'success--text' : 'error--text'"
                    >
                        <div style="white-space: nowrap; width: 120px">Values</div>
                        <div class="flex-grow-1">{{ stat.rollCallValues.total - stat.rollCallValues.fail }} of {{ stat.rollCallValues.total }} Successfull</div>
                    </div>

                    <div
                            v-if="stat.intakeValues.total"
                            class="d-flex align-center px-4 pb-1 overline"
                            style="line-height: 1"
                            :class="!stat.intakeValues.fail ? 'success--text' : 'error--text'"
                    >
                        <div style="white-space: nowrap; width: 120px">Intakes</div>
                        <div class="flex-grow-1">{{ stat.intakeValues.total - stat.intakeValues.fail }} of {{ stat.intakeValues.total }} Successfull</div>
                    </div>

                </div>
                <div class="pa-2">
                    <v-btn
                            color="error"
                            @click="$emit('remove')"
                            small
                            icon
                            class="pa-0 ma-0"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
            </div>

        </v-card>

    </div>
</template>

<script>
import {mapGetters} from "vuex";
import {format} from "date-fns";


const obj = {
    "bins": {"total": 0, "fail": 0},
    "clockings": {"total": 20, "fail": 2},
    "barcodes": {"total": 0, "fail": 0},
    "pieceWorkValues": {"total": 456, "fail": 2},
    "rollCallValues": {"total": 5, "fail": 4},
    "intakeValues": {"total": 0, "fail": 0}
}

export default {
    props: {
        stat: Object
    },
    computed: {
        ...mapGetters(['devicesRef']),
        device() {
            return this.devicesRef[this.stat.deviceId]
        },
        shortDate() {
            return format(new Date(this.stat.date), 'h:maaa')
        }
    }
}
</script>

<style scoped>

</style>